import React, { useState } from 'react';

const MagicLinkSignIn = ({ onSuccess, onError }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSendMagicLink = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setMessage({ 
        type: 'error', 
        text: 'Please enter your email address',
        details: null
      });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      if (onSuccess) {
        const result = await onSuccess('sendMagicLink', email);
        
        if (result?.success) {
          setMessage({ 
            type: 'success', 
            text: result.message || 'Magic link sent! Please check your email inbox and spam folder.',
            details: 'Click the link in the email to sign in. The link will redirect you back to this app.',
          });
        } else {
          const errorText = result?.error || 'Failed to send magic link. Please try again.';
          const errorDetails = result?.errorCode === 'RATE_LIMIT_EXCEEDED' 
            ? 'Supabase default email service limits to 2 emails per hour. Please wait before trying again.'
            : result?.errorCode === 'RATE_LIMIT'
            ? 'Too many requests. Please wait a few minutes.'
            : null;

          setMessage({ 
            type: 'error', 
            text: errorText,
            details: errorDetails,
            errorCode: result?.errorCode
          });
        }
      } else {
        setMessage({ 
          type: 'error', 
          text: 'Authentication service not available. Please refresh the page.',
          details: null
        });
      }
    } catch (err) {
      setMessage({ 
        type: 'error', 
        text: err.message || 'An unexpected error occurred. Please try again.',
        details: 'If this problem persists, please check your internet connection.',
        errorCode: 'EXCEPTION'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="magic-link-signin-container" style={{ padding: '20px', maxWidth: '400px', margin: '0 auto' }}>
      <form onSubmit={handleSendMagicLink}>
        <h2 style={{ marginBottom: '20px', color: '#fff' }}>Sign In with Email</h2>
        
        <div style={{ marginBottom: '15px' }}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid #333',
              backgroundColor: '#1a1a1a',
              color: '#fff',
              fontSize: '14px',
            }}
          />
        </div>

        {message && (
          <div
            style={{
              padding: '12px',
              borderRadius: '8px',
              marginBottom: '15px',
              backgroundColor: message.type === 'error' 
                ? 'rgba(239, 68, 68, 0.15)' 
                : 'rgba(34, 197, 94, 0.15)',
              border: `1px solid ${message.type === 'error' ? 'rgba(239, 68, 68, 0.3)' : 'rgba(34, 197, 94, 0.3)'}`,
              color: message.type === 'error' ? '#ef4444' : '#22c55e',
            }}
          >
            <div style={{ 
              display: 'flex', 
              alignItems: 'flex-start', 
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500',
            }}>
              <span style={{ fontSize: '18px' }}>
                {message.type === 'error' ? '❌' : '✅'}
              </span>
              <div style={{ flex: 1 }}>
                <div>{message.text}</div>
                {message.details && (
                  <div style={{ 
                    marginTop: '6px', 
                    fontSize: '12px', 
                    opacity: 0.9,
                    fontWeight: '400'
                  }}>
                    {message.details}
                  </div>
                )}
                {message.errorCode && message.type === 'error' && (
                  <div style={{ 
                    marginTop: '4px', 
                    fontSize: '11px', 
                    opacity: 0.7,
                    fontFamily: 'monospace'
                  }}>
                    Error Code: {message.errorCode}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: 'none',
            backgroundColor: '#6366f1',
            color: '#fff',
            fontSize: '16px',
            fontWeight: '600',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1,
          }}
        >
          {loading ? 'Sending Magic Link...' : 'Send Magic Link'}
        </button>
      </form>
    </div>
  );
};

export default MagicLinkSignIn;
